import environment from '@/environment';
import { Capacitor } from '@capacitor/core';

const APP_STORE_ID = '6740174843';
const PLAY_STORE_ID = 'com.gyming.main';

export type StoreRedirectContext = {
  platform: string;
  environmentName?: string | null;
  path?: string | null;
  debugFlag: boolean;
};

const isIOS = () => {
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
};

const saveDebugFlag = (debug: boolean) => {
  localStorage.setItem('debug', debug.toString());
};
const getDebugFlag = () => {
  return localStorage.getItem('debug') === 'true';
};

const isProductionWebEnvironment = (environmentName?: string | null) => {
  const name = (environmentName || '').trim().toLowerCase();
  return name === 'production' || name === 'prod';
};

const isNativeDeepLinkPath = (path?: string | null) => {
  if (!path) return false;
  return path === '/login' || path === '/signup' || path.startsWith('/app/');
};

export const shouldNavigateToStore = (newDebug: string | undefined, ctx?: StoreRedirectContext) => {
  if (newDebug !== undefined) {
    saveDebugFlag(newDebug === 'true');
  }
  const platform = ctx?.platform ?? Capacitor.getPlatform();
  const environmentName = ctx?.environmentName ?? environment.name;
  const path = ctx?.path ?? (typeof window !== 'undefined' ? window.location.pathname : '');
  const debugFlag = ctx?.debugFlag ?? getDebugFlag();

  if (platform !== 'web') return false;
  if (!isProductionWebEnvironment(environmentName)) return false;
  if (debugFlag) return false;
  // Shared Post URLs (and other in-app routes) must remain usable in the browser
  // when the native app is not installed. Do not hijack into the stores.
  if (isNativeDeepLinkPath(path)) return false;
  return true;
};

export const navigateToStore = async () => {
  const storeUrl = isIOS()
    ? `https://apps.apple.com/app/id${APP_STORE_ID}`
    : `https://play.google.com/store/apps/details?id=${PLAY_STORE_ID}`;
  window.location.replace(storeUrl);
};
